import { Currency } from './enums';

/** Símbolos de moneda como se escriben en Perú (el código ISO sigue siendo el valor que viaja a la API). */
export const CURRENCY_SYMBOLS: Record<Currency, string> = { USD: 'US$', PEN: 'S/' };

/** «US$» / «S/»; un código desconocido se muestra tal cual. */
export function currencySymbol(currency: string | null | undefined): string {
  if (!currency) return '';
  return (CURRENCY_SYMBOLS as Record<string, string>)[currency] ?? currency;
}

/**
 * Monto con su símbolo, como lo escribe el equipo: «US$ 152,000», «S/ 350,000.50» (miles con coma, decimales con
 * punto, `es-PE`). Los centavos se muestran solo cuando los hay (ux-comercial-25): una proforma de 152,000.50 no se
 * redondea; `{ decimals: 0 }` fuerza el entero para resúmenes y tarjetas. Un valor vacío o no numérico es «—».
 */
export function formatMoney(
  value: string | number | null | undefined,
  currency: string | null | undefined = Currency.USD,
  opts: { decimals?: 'auto' | 0 } = {},
): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const cents = opts.decimals === 0 || Math.round(Math.abs(n) * 100) % 100 === 0 ? 0 : 2;
  const text = new Intl.NumberFormat('es-PE', {
    minimumFractionDigits: cents,
    maximumFractionDigits: cents,
  }).format(n);
  const symbol = currencySymbol(currency);
  return symbol ? `${symbol} ${text}` : text;
}
